import { httpsCallable } from "firebase/functions";
import { functions } from "@poseidon/firebase";

/**
 * Creates a new sailor's account on behalf of an admin by calling the
 * `adminCreateSailorAccount` Cloud Function. The function creates the auth user,
 * writes `sailors/{uid}` with the first/last name, and sets the sailor claim —
 * all server-side with the Admin SDK.
 *
 * This replaces the previous browser-side approach (secondary Firebase app +
 * `createUserWithEmailAndPassword` + `setDoc` merge), which raced with the
 * blocking `beforeSignIn` trigger and could leave the sailor doc with blank
 * names (and hit `auth/user-not-found` when setting claims).
 *
 * Returns the new `uid` and the one-time generated `password`.
 */
export const useCreateSailorAccount = () => {
  const createAccount = async ({ email, firstName, lastName }) => {
    const callable = httpsCallable(functions, "adminCreateSailorAccount");
    const { data } = await callable({ email, firstName, lastName });
    return { uid: data.uid, password: data.password };
  };

  return { createAccount };
};
